import CleanoutItemProps from "../props/CleanoutItems"

const transformCleanoutItemsToArray = (items:string) => {
  const transformedItems:CleanoutItemProps[] = []
  Object.values(JSON.parse(items)).forEach((item) => {
    transformedItems.push(item as CleanoutItemProps)
  })

  return transformedItems
}

export {
  transformCleanoutItemsToArray
}
